// extracted by mini-css-extract-plugin
export default {"anouncementsTable":"AnouncementTable_anouncementsTable__+mXXQ","annoucementTable":"AnouncementTable_annoucementTable__R-gWj"};